/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo, PropsWithChildren } from 'react';

import logo from '../../assets/images/scalefield_logo.svg';
import { LanguagePicker } from '../../components/LanguagePicker/LanguagePicker';
import { useSetupLayoutStyles } from './SetupLayout.styles';

export const SetupLayout = memo<PropsWithChildren>(props => {
  const classes = useSetupLayoutStyles();

  return (
    <div className={classes.root}>
      <div className={classes.heading}>
        <div className={classes.logoWrap}>
          <img alt="logo img" src={logo} className={classes.logo} />
        </div>
        <div className={classes.lang}>
          <LanguagePicker />
        </div>
      </div>
      <div className={classes.children}>{props.children}</div>
    </div>
  );
});
